import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import { api } from "../api";
import { useAuth } from "../contexts/AuthContext";
import { AUTH } from "../constants/testIds";

const GENDERS = [["male","Male"],["female","Female"],["prefer_not_to_say","Prefer not to say"]];
const SECTS = [["sunni","Sunni"],["shia","Shia"],["prefer_not_to_say","Prefer not to say"]];
const MADHABS = [["hanafi","Hanafi"],["maliki","Maliki"],["shafii","Shafi'i"],["hanbali","Hanbali"],["not_specified","Not applicable"]];
const LANGS = [["en","English"],["ar","Arabic"],["ms","Malay"],["ta","Tamil"],["id","Bahasa Indonesia"],["zh","Chinese"]];

export default function Signup() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({
    full_name: "", date_of_birth: "", gender: "male", sect: "sunni",
    madhab: "hanafi", preferred_language: "en",
    email: "", password: "", confirm: "",
  });
  const [terms, setTerms] = useState(false);
  const [busy, setBusy] = useState(false);

  const f = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error("Passwords don't match");
    if (form.password.length < 8) return toast.error("Password min 8 chars");
    if (!terms) return toast.error("Please accept the Terms & Conditions");
    setBusy(true);
    try {
      const { confirm, ...payload } = form;
      const r = await api.post("/auth/signup", { ...payload, terms_accepted: true });
      login(r.data.token, r.data.user);
      toast.success("Alhamdulillah! Welcome to Dnya");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="dnya-pattern" style={{ minHeight: "100vh", padding: 24, background: "var(--dnya-bg)" }}>
      <form onSubmit={submit} style={{ maxWidth: 520, margin: "0 auto", background: "var(--dnya-card)", border: `1px solid var(--dnya-mosaic-1)`, borderRadius: 16, padding: 28 }} className="dnya-reveal">
        <div style={{ textAlign: "center" }}><Logo size={72} /></div>
        <h1 className="font-dnya" style={{ fontSize: 26, color: "var(--dnya-high-1)", textAlign: "center", marginTop: 14, marginBottom: 18 }}>
          Create Your Account
        </h1>

        <Field label="Full Name">
          <input data-testid={AUTH.signupName} required value={form.full_name} onChange={f("full_name")} style={inp} />
        </Field>
        <div style={row}>
          <Field label="Date of Birth"><input type="date" value={form.date_of_birth} onChange={f("date_of_birth")} style={inp} /></Field>
          <Field label="Gender"><select value={form.gender} onChange={f("gender")} style={inp}>{GENDERS.map(([v,l]) => <option key={v} value={v}>{l}</option>)}</select></Field>
        </div>
        <div style={row}>
          <Field label="Sect"><select value={form.sect} onChange={f("sect")} style={inp}>{SECTS.map(([v,l]) => <option key={v} value={v}>{l}</option>)}</select></Field>
          <Field label="Madhab"><select value={form.madhab} onChange={f("madhab")} style={inp}>{MADHABS.map(([v,l]) => <option key={v} value={v}>{l}</option>)}</select></Field>
        </div>
        <Field label="Preferred Language">
          <select value={form.preferred_language} onChange={f("preferred_language")} style={inp}>{LANGS.map(([v,l]) => <option key={v} value={v}>{l}</option>)}</select>
        </Field>
        <Field label="Email">
          <input data-testid={AUTH.signupEmail} type="email" required value={form.email} onChange={f("email")} style={inp} />
        </Field>
        <div style={row}>
          <Field label="Password"><input data-testid={AUTH.signupPassword} type="password" required value={form.password} onChange={f("password")} style={inp} /></Field>
          <Field label="Confirm"><input data-testid={AUTH.signupConfirm} type="password" required value={form.confirm} onChange={f("confirm")} style={inp} /></Field>
        </div>

        <label style={{ display: "flex", alignItems: "flex-start", gap: 10, margin: "18px 0", color: "var(--dnya-text)", fontSize: 13 }}>
          <input data-testid={AUTH.signupTerms} type="checkbox" checked={terms} onChange={(e) => setTerms(e.target.checked)}
            style={{ marginTop: 3, accentColor: "var(--dnya-high-1)" }} />
          <span>I have read and agree to the{" "}
            <Link to="/terms" target="_blank" style={{ color: "var(--dnya-high-1)", textDecoration: "underline" }}>Terms and Conditions</Link>
          </span>
        </label>

        <button data-testid={AUTH.signupSubmit} type="submit" disabled={busy || !terms} style={{ width: "100%", padding: "12px", borderRadius: 10, background: terms ? "var(--dnya-mosaic-1)" : "var(--dnya-mosaic-2)", color: "#ffffff", border: 0, fontSize: 15, fontWeight: 600, cursor: terms ? "pointer" : "not-allowed", opacity: terms ? 1 : 0.55 }}>
          {busy ? "Bismillah..." : "Sign Up"}
        </button>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 13, color: "var(--dnya-high-2)" }}>
          Already have an account?{" "}
          <Link data-testid={AUTH.goToLogin} to="/login" style={{ color: "var(--dnya-high-1)", fontWeight: 600 }}>Login</Link>
        </div>
      </form>
    </div>
  );
}

const inp = { width: "100%", padding: "10px 12px", borderRadius: 10, border: `1px solid var(--dnya-border)`, background: "var(--dnya-input-bg)", color: "var(--dnya-text)", outline: "none", fontSize: 14 };
const row = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 };

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <div style={{ fontSize: 11, color: "var(--dnya-high-1)", marginBottom: 5, fontWeight: 500, letterSpacing: "0.05em", textTransform: "uppercase" }}>{label}</div>
    {children}
  </div>
);
